import { Link } from 'react-router-dom'
import Navbar from '../components/Navbar'
import SEO from '../components/SEO'

const DISCORD_INVITE_URL = 'https://discord.gg/gu7fFhgTJW'

export default function AtCapacityPage() {
  return (
    <>
      <SEO
        title="We're at capacity"
        description="Verse is currently full. Join our Discord to be notified when new spots open."
      />
      <Navbar />
      <div className="auth-success">
        <div className="auth-success__card">
          <div className="auth-success__icon">✨</div>
          <h2 className="auth-success__title">We're at capacity.</h2>
          <p className="auth-success__desc">
            Verse is currently full. Join our Discord to get notified
            the moment new spots open up — we're excited to welcome
            you soon.
          </p>

          <a
            href={DISCORD_INVITE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="btn btn-primary auth-submit"
            style={{ marginTop: 8 }}
          >
            Join Discord
          </a>

          <p className="auth-switch" style={{ marginTop: 16 }}>
            Already have an account?{' '}
            <Link to="/login" className="auth-switch-link">Sign in</Link>
          </p>
        </div>
      </div>
    </>
  )
}
